module.exports = __webpack_public_path__ + "img/energie.4d4dee70.svg";